import {NotificationTypes} from "../const/const";
import {
    getNotificationCoauthorAddText, getNotificationCoauthorRemoveText,
    getNotificationLikeText,
    getNotificationLMSAddText,
    getNotificationLMSApproveText,
    getNotificationLMSCommentText, getNotificationSendFileText, getNotificationSimpleText,
    getNotificationProjectBannedText
} from "./notificationTexts";

export const getNotificationTitle = (item: any, t: any) => {

    const {
        actions,
    } = item;

    // @ts-ignore
    const NotificationTitleList: Record<NotificationTypes, any> = {
        [NotificationTypes.LIKE]: getNotificationLikeText,
        [NotificationTypes.SIMPLE]: getNotificationSimpleText,
        [NotificationTypes.LMS_HOMEWORK_COMMENT]: getNotificationLMSCommentText,
        [NotificationTypes.LMS_HOMEWORK_APPROVE]: getNotificationLMSApproveText,
        [NotificationTypes.LMS_HOMEWORK_ADD]: getNotificationLMSAddText,
        [NotificationTypes.SEND_FILE]: getNotificationSendFileText,
        [NotificationTypes.COAUTHOR_ADD]: getNotificationCoauthorAddText,
        [NotificationTypes.COAUTHOR_REMOVE]: getNotificationCoauthorRemoveText,
        [NotificationTypes.PROJECT_BANNED]: getNotificationProjectBannedText
    }

    const notificationType: NotificationTypes = actions?.length > 0 ? (actions[0]?.type || '') : ''
    const activeTitleGetter = typeof NotificationTitleList[notificationType] !== "undefined" ? NotificationTitleList[notificationType] : undefined

    return activeTitleGetter ? activeTitleGetter(item, t) : ""
}import {NotificationTypes} from "../const/const";
import {
    getNotificationCoauthorAddText, getNotificationCoauthorRemoveText,
    getNotificationLikeText,
    getNotificationLMSAddText,
    getNotificationLMSApproveText,
    getNotificationLMSCommentText, getNotificationSendFileText, getNotificationSimpleText,
    getNotificationProjectBannedText
} from "./notificationTexts";

export const getNotificationTitle = (item: any, t: any) => {

    const {
        actions,
    } = item;

    // @ts-ignore
    const NotificationTitleList: Record<NotificationTypes, any> = {
        [NotificationTypes.LIKE]: getNotificationLikeText,
        [NotificationTypes.SIMPLE]: getNotificationSimpleText,
        [NotificationTypes.LMS_HOMEWORK_COMMENT]: getNotificationLMSCommentText,
        [NotificationTypes.LMS_HOMEWORK_APPROVE]: getNotificationLMSApproveText,
        [NotificationTypes.LMS_HOMEWORK_ADD]: getNotificationLMSAddText,
        [NotificationTypes.SEND_FILE]: getNotificationSendFileText,
        [NotificationTypes.COAUTHOR_ADD]: getNotificationCoauthorAddText,
        [NotificationTypes.COAUTHOR_REMOVE]: getNotificationCoauthorRemoveText,
        [NotificationTypes.PROJECT_BANNED]: getNotificationProjectBannedText
    }

    const notificationType: NotificationTypes = actions?.length > 0 ? (actions[0]?.type || '') : ''
    const activeTitleGetter = typeof NotificationTitleList[notificationType] !== "undefined" ? NotificationTitleList[notificationType] : undefined

    return activeTitleGetter ? activeTitleGetter(item, t) : ""
}